import Constants from '../constants/constants';
import { dispatcher } from '../dispatcher/dispatcher';

const { ActionTypes } = Constants;

export const ConfirmationModalActions = {
    //write actions here
    validateBeforeSubmitting: function () {
        dispatcher.dispatch({
            type: ActionTypes.VALIDATE_FORM_B_RESTRICTION,
        });
    },

    superAuthChanged: function (value) {
        dispatcher.dispatch({
            type: ActionTypes.SUPERVISOR_AUTH_SET,
            value: value
        });
    },

    confirmationChanged: function (value) {
        dispatcher.dispatch({
            type: ActionTypes.CONFIRM_SET,
            value: value
        });
    },

    sloDtChanged: function (value) {
        dispatcher.dispatch({
            type: ActionTypes.SLODT_SET,
            value: value
        });
    },

    formCDtChanged: function (value) {
        dispatcher.dispatch({
            type: ActionTypes.FORMCDT_SET,
            value: value
        });
    },

    formTCMDtChanged: function (value) {
        dispatcher.dispatch({
            type: ActionTypes.FORMTCMDT_SET,
            value: value
        });
    },

    radioChanged: function (id, value) {
        dispatcher.dispatch({
            type: ActionTypes.REQUEST_RADIO_CHANGED,
            value: value,
            id: id
        });
    }
};
